/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_ReportInputs */

const cs_gdpr_review_report = /** @type {(inputs: Gdpr_Review_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkušební běh (nic nemění)`)
};

const en_gdpr_review_report = /** @type {(inputs: Gdpr_Review_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry run (changes nothing)`)
};

/**
* | output |
* | --- |
* | "Dry run (changes nothing)" |
*
* @param {Gdpr_Review_ReportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_report = /** @type {((inputs?: Gdpr_Review_ReportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_ReportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_report(inputs)
	return cs_gdpr_review_report(inputs)
});